export const LOADING_LABOUR = "LOADING_LABOUR";
export const GET_LABOUR_LIST = "GET_LABOUR_LIST";
export const REMOVE_LABOUR = "REMOVE_LABOUR";
export const ADD_LABOUR = "ADD_LABOUR";
export const UPDATE_LABOUR = "UPDATE_LABOUR";